import { Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef} from '@angular/material/snack-bar';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) {}

  public showInfoModal(message: string): void {
    Swal.fire({
      text: message,
      icon: 'info',
      showCancelButton: false,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false,
    });
  }

  public showSnackBar(
    message: string,
    tipo: 'error' | 'success' | 'info' | 'warning' = 'info',
    duration: number = 15000
  ): void {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.duration = duration;
    config.panelClass = [`${tipo}-snackbar`, 'snackbar-class'];
    this.snackBar.open(message, 'x', config);

  }
}
